export enum RaterStep {
  Vehicle,
  Plans,
  Menu,
  Finalize,
}
